module.exports = __webpack_public_path__ + "static/media/tutorial3.913e92ab.mp4";